import { Controller } from "@hotwired/stimulus"

// Live preview for the Fuhrpark name format. Unlike site_name_format_preview this one
// renders EVERY format on the server (not just the custom template), so the preview and
// Fleet#display_name cannot drift apart.
export default class extends Controller {
  static targets = ["select", "preview", "customBlock", "template"]

  static values = { previewUrl: String }

  connect() {
    this.toggleCustomBlock()
  }

  update() {
    this.toggleCustomBlock()
    this.refreshPreview()
  }

  toggleCustomBlock() {
    if (!this.hasCustomBlockTarget) return
    this.customBlockTarget.classList.toggle("hidden", this.selectTarget.value !== "custom")
  }

  insertToken(event) {
    const token = event.currentTarget.dataset.token
    if (!this.hasTemplateTarget || !token) return

    const input = this.templateTarget
    const start = input.selectionStart ?? input.value.length
    const end = input.selectionEnd ?? input.value.length
    input.value = input.value.slice(0, start) + token + input.value.slice(end)
    const caret = start + token.length
    input.setSelectionRange(caret, caret)
    input.focus()
    this.refreshPreview()
  }

  applyExample(event) {
    const template = event.currentTarget.dataset.template
    if (!this.hasTemplateTarget || !template) return

    this.templateTarget.value = template
    this.templateTarget.focus()
    this.refreshPreview()
  }

  async refreshPreview() {
    if (!this.hasPreviewUrlValue || !this.hasPreviewTarget) return

    const params = new URLSearchParams({ name_format: this.selectTarget.value })
    if (this.hasTemplateTarget) params.set("template", this.templateTarget.value)

    try {
      const response = await fetch(`${this.previewUrlValue}?${params}`, {
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
      })
      if (response.ok) {
        this.previewTarget.textContent = await response.text()
      }
    } catch (error) {
      console.error("Failed to update fleet name preview:", error)
    }
  }
}
